import _ from 'lodash';

const fieldsToRemove = ['updatedDate', 'createdDate'];
export const prepDataSource = (data) => _.omit(data, fieldsToRemove);
